import React from "react";
import PropTypes from 'prop-types';
import Steps from "./steps";

const Alerts = ({ alerts }) => {

    const steps = alerts.map(a => ({ title: a.title, description: a.content }));

    return (
        <>
            {
                alerts && alerts.length !== 0 &&
                <div id="alerts-box" className="alerts-box">
                    <span className="text-red-500 font-bold text-lg">Alerts Center</span>
                    <span className="page-subheader text-red-500 text-justify">Please resolve the following issues. Failure to do so may limit your access to Sunbound features.</span>
                    <Steps steps={steps} className="alert" />
                </div>
            }
        </>
    );
};

Alerts.propTypes = {
    alerts: PropTypes.array
};

export default Alerts;